import { render, staticRenderFns } from "./CadastroComplementos.vue?vue&type=template&id=51810ab7&"
import script from "./CadastroComplementos.vue?vue&type=script&lang=js&"
export * from "./CadastroComplementos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports